
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"1em","height":"1em","fill":"currentColor","viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14 4c-2.871 0-5.44 2.024-6.494 5H13a1 1 0 110 2H7.053a9.316 9.316 0 000 2H13a1 1 0 110 2H7.506c1.053 2.976 3.623 5 6.494 5 1.137 0 2.212-.31 3.166-.864a1 1 0 011.005 1.728A8.262 8.262 0 0114 22c-4.102 0-7.45-2.997-8.585-7H3a1 1 0 110-2h2.045a11.127 11.127 0 010-2H3a1 1 0 110-2h2.415C6.55 4.997 9.898 2 14 2c1.508 0 2.928.412 4.171 1.136a1 1 0 01-1.005 1.728A6.263 6.263 0 0014 4z"}})])
          )
        }
      }
    